import { TagType } from '../../_models/Tag';

export const DEFAULT_TAG_COLOR = {
  hex: '#EA475C',
  rgb: { r: 234, g: 71, b: 92 },
};
export const TAG_DEFAULT = {
  custom: true,
  title: null,
  description: null,
  positionX: null,
  positionY: null,
  positionZ: null,
  iconColor: DEFAULT_TAG_COLOR.hex,
  icon: null,
  opacity: 100,
  sid: null,
  enabled: true,
  type: TagType.None,
  text: null,
  res: 'pixels',
  whiteCircle: false,
  transparentBackground: false,
  tooltip: true,
};
